import React, { useCallback, useMemo } from 'react';
import { ScrollContext } from './ScrollContext';
import { useOnLayoutChange } from '../../v2BaseComponents/LayoutChangeEventProvider';
import { FlatList, ScrollView } from 'react-native';

export type ScrollContextProviderOwnProps = {
    scrollRef: React.RefObject<ScrollView | FlatList | null> | null;
    children: (onScroll: () => void) => React.ReactNode;
};

export type ScrollContextProviderProps = ScrollContextProviderOwnProps;

const SCROLL_STOP_DELAY = 300;

const ScrollContextProvider: React.FC<ScrollContextProviderProps> = (props) => {
    const scrollStopTimer = React.useRef<NodeJS.Timeout | null>(null);
    const parentScrollContext = React.useContext(ScrollContext);
    const onLayoutChange = useOnLayoutChange();

    const onScroll = useCallback(() => {
        if (parentScrollContext.isInScroll) {
            parentScrollContext.onScroll;
        } else {
            if (scrollStopTimer.current) {
                clearTimeout(scrollStopTimer.current);
            }

            // Set a new timer to detect scroll end
            scrollStopTimer.current = setTimeout(onLayoutChange, SCROLL_STOP_DELAY);
        }
    }, [onLayoutChange, parentScrollContext.isInScroll, parentScrollContext.onScroll]);

    const context: ScrollContext = useMemo(
        () => ({
            isInScroll: true,
            onScroll,
            scrollRef: props.scrollRef,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [onScroll],
    );

    return <ScrollContext.Provider value={context}>{props.children(onScroll)}</ScrollContext.Provider>;
};

export default React.memo(ScrollContextProvider);
